export enum ConfirmationDialogType {
  Danger,
  Warning,
}
